import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/layouts/Main.vue'),
    children: [
      {
        path: '',
        name: 'dashboard',
        component: () => import('@/views/Dashboard.vue')
      },
      {
        path: 'edit-job',
        name: 'edit-job',
        component: () => import('@/views/EditJob.vue')
      },
      {
        path: 'notifications',
        name: 'notifications',
        component: () => import('@/views/Notifications.vue')
      },
      {
        path: 'preview-job',
        name: 'preview-job',
        component: () => import('@/views/JobPreview.vue')
      },
      {
        path: 'settings',
        name: 'settings',
        component: () => import('@/views/UserSettings.vue')
      },
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/Admin.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/sign-up',
    component: () => import('@/views/SignUp.vue')
  },
  {
    path: '/password-reset',
    component: () => import('@/views/PasswordReset.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes: routes
})

export default router